var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccruentGreyscaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Accruent_Greyscale_Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".accurent-greyscale-cls-1{fill:#333;}.accurent-greyscale-cls-2{fill:#b3b3b3;}.accurent-greyscale-cls-3{fill:#666;}.accurent-greyscale-cls-4{fill:#999;}.accurent-greyscale-cls-5{fill:gray;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grayscale_-_icon",
    "data-name": "Grayscale - icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "accurent-greyscale-cls-1",
    d: "M103.4,127.1h-51a29.45,29.45,0,1,0,25.49,44.15l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accurent-greyscale-cls-2",
    d: "M171.43,127.1h-51l25.51,44.18v0a29.44,29.44,0,1,0,25.5-44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accurent-greyscale-cls-3",
    d: "M52.39,127.1h51l-29.46-51a43.53,43.53,0,0,1-4-8.8L26.88,141.82h0A29.39,29.39,0,0,1,52.39,127.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accurent-greyscale-cls-4",
    d: "M196.9,141.82h0l-43-74.56a43.56,43.56,0,0,1-4,8.8l-29.46,51h51A29.38,29.38,0,0,1,196.9,141.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accurent-greyscale-cls-5",
    d: "M141.36,53.46A29.46,29.46,0,1,0,86.42,68.19h0l25.51,44.18,25.5-44.18h0A29.32,29.32,0,0,0,141.36,53.46Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccruentGreyscaleIcon);
export default __webpack_public_path__ + "static/media/AccruentGreyscaleIcon.b2e5967f.svg";
export { ForwardRef as ReactComponent };